import { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import useGetUser from "../../../hooks/useGetUser";

import DefRoutes from "../../../routes/routes.json";
import t from "../../../i18n/i18n";
import useApi from "../../../services/api";
import { SignIn } from "../../../store/reducers/auth.reducer";
import { handleApiErrors } from "../../../utils/handleErrors";

import Input from "../../../components/form/input";

export const TFAIFrame = () => {
  useGetUser();
  const [resend, setResend] = useState({ canResend: false, time: 59 });

  const dispatch = useDispatch();

  const { push } = useHistory();
  const {
    state: { tfa: token },
  } = useLocation();

  const { ApiSignInTFA, ApiGenerateNewCode } = useApi();

  const [form, setForm] = useState({ tfa: !!localStorage.getItem("@TFA/Authorization") });

  function handleInputChange(e) {
    setForm({ ...form, code: e.target.value });
  }

  async function TFASubmit(e) {
    e.preventDefault();

    console.log("form", form);

    form.tfa ? localStorage.setItem("@TFA/Authorization", "true") : localStorage.removeItem("@TFA/Authorization");

    const { data } = await ApiSignInTFA({ ...form });

    if (data.errors) {
      return handleApiErrors(data.errors);
    }

    dispatch(SignIn(data));

    window.parent.postMessage({ action: "login" }, "*");

    return push(DefRoutes.Embed.Profile);
  }

  function handleAuthorization() {
    setForm({ ...form, tfa: !form.tfa });
  }

  function handleResend() {
    let time = 59;

    const interval = setInterval(() => {
      time -= 1;

      if (time === 0) {
        setResend({ ...resend, canResend: true });
        clearInterval(interval);
      } else {
        setResend({ ...resend, canResend: false, time: time.toString().padStart(2, 0) });
      }
    }, 1000);
  }

  useEffect(() => {
    handleResend();
    setForm({ ...form, token });
  }, []);

  async function resendCode() {
    const { data } = await ApiGenerateNewCode(token);

    setForm({ ...form, token: data.tfa });

    handleResend();

    // token = data.tfa;
  }

  return (
    <div className="user-form-box vh-100 d-flex flex-column justify-content-around">
      <h1>{t("TFA.TFA")}</h1>
      <p>{t("TFA.Description")}</p>
      <form onSubmit={TFASubmit}>
        <Input label={t("TFA.Label")} name="login" value={form.code || ""} onChange={handleInputChange} />

        <div className="input-box input-check">
          <input type="checkbox" id="tfa" checked={form.tfa} onClick={() => handleAuthorization()} />
          <label
            for="tfa"
            dangerouslySetInnerHTML={{
              __html: t("TFA.Cookie"),
            }}
          />
        </div>

        <div className="button-conform" style={{ justifyContent: "space-between" }}>
          {!resend.canResend && <p>{t("TFA.Resend", { time: `00:${resend.time}` })}</p>}
          {resend.canResend && (
            <button type="button" className="img-btn" onClick={resendCode}>
              {t("TFA.ResendCode")}
            </button>
          )}
          <button type="submit" className="img-btn btn-confirmar">
            {t("TFA.SignIn")}
          </button>
        </div>
      </form>
    </div>
  );
};

export default TFAIFrame;
